<template>
  <div>
    <vs-table
      search
      stripe
      border
      description
      v-model="itemSelected"
      :sst="true"
      :data="table.data"
      :max-items="table.length"
      :total="table.total"
      @change-page="handleChangePage"
      @search="handleSearch"
      @sort="handleSort"
    >
      <template slot="header">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ this.table.start }} - {{ this.table.end }} of
              {{ this.table.total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="item in table.limits"
              :key="item"
              @click="handleChangelength(item)"
            >
              <span>{{ item }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>
      <template slot="thead">
        <!-- <vs-th
                    ><vs-checkbox
                      v-model="selectAll"
                      @input="handleSelectAll"
                    />ALL</vs-th
                  > -->

        <vs-th>Select</vs-th>
        <vs-th>Shipment Data</vs-th>
        <vs-th>Driver</vs-th>
        <vs-th>Customer Data</vs-th>
        <!-- <vs-th sort-key="name">SO Data</vs-th> -->
        <vs-th>DO/DN Data</vs-th>
        <!-- <vs-th sort-key="name">List Item</vs-th> -->
        <vs-th>Payment Term</vs-th>
        <vs-th>Source</vs-th>
        <vs-th>POD Status</vs-th>
        <vs-th>Document</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <feather-icon
              icon="EyeIcon"
              svgClasses="w-5 h-5 hover:text-primary stroke-current"
              class="ml-4"
              @click="handleEdit(tr)"
            />
          </vs-td>

          <vs-td>
            <ol class="bullet-list">
              <li>
                {{ tr.shipment_number }}
              </li>
              <li>
                {{ tr.delivery_date }}
              </li>
            </ol>
          </vs-td>
          <vs-td>
            <ol class="bullet-list">
              <li>
                {{ tr.driver_name }}
              </li>
              <li>
                {{ tr.vehicle_number }}
              </li>
            </ol>
          </vs-td>
          <vs-td>
            <ol class="bullet-list">
              <li>
                {{ tr.customer_code }}
              </li>
              <li>
                {{ tr.customer_name }}
              </li>
              <li>
                {{ tr.zone_name }}
              </li>
            </ol>
          </vs-td>
          <!-- <vs-td>
            <ol>
              <li>
                {{ tr.sales_order_code }}
              </li>
            </ol>
          </vs-td> -->
          <vs-td>
            <ol class="bullet-list">
              <li>{{ tr.delivery_order_code }}</li>
              <li>{{ tr.customer_name }}</li>
            </ol>
          </vs-td>
          <!-- <vs-td>
            <ol v-for="(item, index) in tr.items_pod" :key="index">
              <li>{{ index + 1 }}. {{ item.item_name }}</li>
            </ol>
          </vs-td> -->
          <vs-td>
            {{ tr.payment_term }}
          </vs-td>
          <vs-td>
            {{ tr.notes }}
          </vs-td>
          <vs-td>
            {{ tr.status_delivery ? tr.status_delivery : "" }}
          </vs-td>
          <vs-td>
            <div class="vx-input-group flex">
              <vs-checkbox
                :vs-value="tr"
                color="success"
                disabled
                :checked="tr.is_document"
              />
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination
      style="padding-top: 5px"
      :total="table.totalPage"
      v-model="setPage"
    />
  </div>
</template>

<script>
import moment from "moment";
export default {
  components: {},

  mounted() {
    this.getDatas();
  },
  props: {
    transportPlanID: {
      type: Number,
      default: null,
    },
    warehouseID: {
      type: Number,
      default: null,
    },
    driverName: {
      type: String,
      default: null,
    },
    dateStart: {
      type: String,
      default: "",
    },
    dateEnd: {
      type: String,
      default: "",
    },
    selectedStatus: {
      type: Object,
      default: null,
    },
    isFilters: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      itemSelected: [],
      deleteId: null,
      table: this.tableDefaultState(),
      transportPlan: [],
      exportID: [],
      IDwasGenerate: [],
      showingData: true,
      selectAll: false,
      cartPODConfirm: [],
      cartTransportPlan: [],
    };
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      if (searching == "") {
        this.table.length = 10;
      }
      this.table.page = 1;
      this.getDatas();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getDatas();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getDatas();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getDatas();
    },

    getDatas() {
      console.log(">>>>>get data", this.isFilters);
      this.$vs.loading();
      this.table.data = [];
      this.IDItem = [];
      this.itemSelected = [];
      this.$http
        .get("/api/wms/v1/proof-of-delivery/all", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            transport_plan_id: this.transportPlanID,
            warehouse_id: this.$store.getters["pod/pod/getWarehouseID"],
            date_from: this.dateStart,
            date_to: this.dateEnd,
            driver_name: this.driverName ? this.driverName : null,
            status_delivery: this.selectedStatus
              ? this.selectedStatus.id
              : null,
            status: 9,
          },
        })
        .then((resp) => {
          console.log("rrrrrrr", resp);
          if (resp.code == 200) {
            if (resp.data.records != null) {
              this.table.data = [];
              this.table.total = resp.data.total_record;
              this.table.totalPage = resp.data.total_page;
              this.table.totalSearch = resp.data.total_record_search;
              this.table.length = resp.data.total_record_per_page;
              this.table.data = resp.data.records;
              for (let index = 0; index < resp.data.records.length; index++) {
                this.table.data[index]["indextr"] = index;
                this.table.data[index]["source"] = "Manual";
              }
              this.$emit("isFilters", false);
              this.setStartEnd();
            } else {
              this.table.data = [];
              this.table.total = 0;
              this.table.totalPage = 0;
              this.table.totalSearch = 0;
              this.table.length = 0;
              this.table.data = [];
              this.setStartEnd();
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }

      if (this.table.total == 0) {
        valStart = 0;
      }

      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (this.totalSearch < this.total) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    handleEdit(data) {
      console.log("data", data);
      this.$vs.loading();
      this.$router.push({
        name: "proof-of-delivery-show-tab-all",
        query: {
          id: data.id,
          action: "Show",
        },
      });
      this.$vs.loading.close();
    },
  },
  watch: {
    detail() {},
    isFilters(val) {
      if (val) {
        this.getDatas();
        this.$emit("isFilters", false);
      }
    },
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
  filters: {
    formatDate(val) {
      return moment(val)
        .add(-7, "h")
        .utc()
        .local()
        .format("DD MMM YYYY HH:mm:ss");
    },
  },
};
</script>
<style>
.bullet-list {
  list-style-type: disc; /* Atur tipe tanda (dalam hal ini tanda titik) */
  padding-left: 20px; /* Atur jarak kiri untuk membuat tanda tampak lebih baik */
}
</style>
